import { MenuNodeType } from "components/Menu/model";

import { REMOTE_APP_ROUTE_CONFIGS } from "../Routes.remotes";

import { Language, LANGUAGE_CONFIG, LANGUAGE_MAPPING } from "./language";

export const getFirstPathnameSegment = (pathname: string) =>
  pathname.split("/")[1];

export const getPathnameWithoutFirstSegment = (pathname: string) =>
  `/${pathname.split("/").slice(2).join("/")}`;

export const getUrlWithoutHash = (href: string) => href.split("#")[0];

export const isShellRemoteAppUrl = (pathname: string) => {
  const pathnameFirstSegment = getFirstPathnameSegment(pathname);
  return REMOTE_APP_ROUTE_CONFIGS[pathnameFirstSegment] !== undefined;
};

export const isHomepageUrl = (
  pathname: string,
  languageNodes: MenuNodeType.Link[]
) => languageNodes.some((languageItem) => languageItem.href === pathname);

export const isAEMUrl = (pathname: string) =>
  pathname === "/" || pathname.startsWith("/web/");

export const isLegacyUrl = (pathname: string) =>
  !(isShellRemoteAppUrl(pathname) || isAEMUrl(pathname));

export const isLegacySectorRegionUrl = (pathname: string) =>
  pathname.startsWith("/researchandratings") ||
  pathname.startsWith("/ja/researchandratings") ||
  pathname.startsWith("/zh-cn/researchandratings");

export const isChineseOrJapaneseCV2Url = (pathname: string) => {
  const firstPathnameSegment = getFirstPathnameSegment(pathname);
  return (
    firstPathnameSegment === Language.CHINESE ||
    firstPathnameSegment === Language.JAPANESE
  );
};

export const updateCV2LanguageUrl = (language: Language, href: string) => {
  const transformedUrl = new URL(href);
  const languagePrefix = language === Language.ENGLISH ? "" : `/${language}`;

  if (isChineseOrJapaneseCV2Url(transformedUrl.pathname)) {
    transformedUrl.pathname = `${languagePrefix}${getPathnameWithoutFirstSegment(
      transformedUrl.pathname
    )}`;
  } else {
    transformedUrl.pathname = `${languagePrefix}${transformedUrl.pathname}`;
  }

  return transformedUrl.toString();
};

export const updateCV1LanguageUrl = (language: Language, href: string) => {
  const transformedUrl = new URL(href);
  const searchParams = transformedUrl.searchParams;
  const currentLanguageParam = searchParams
    .get(LANGUAGE_CONFIG.LANGUAGE_QUERY_PARAM)
    ?.toLowerCase();

  if (currentLanguageParam === language) {
    return href;
  }

  if (currentLanguageParam) {
    searchParams.delete(LANGUAGE_CONFIG.LANGUAGE_QUERY_PARAM);
    searchParams.delete(LANGUAGE_CONFIG.COUNTRY_QUERY_PARAM);
  }

  searchParams.append(LANGUAGE_CONFIG.LANGUAGE_QUERY_PARAM, language);
  searchParams.append(
    LANGUAGE_CONFIG.COUNTRY_QUERY_PARAM,
    LANGUAGE_MAPPING[language].legacyCountry
  );
  return transformedUrl.toString();
};
